import { render, staticRenderFns } from "./Gateways.vue?vue&type=template&id=4681c57d&scoped=true"
import script from "./Gateways.vue?vue&type=script&lang=js"
export * from "./Gateways.vue?vue&type=script&lang=js"
import style0 from "./Gateways.vue?vue&type=style&index=0&id=4681c57d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681c57d",
  null
  
)

export default component.exports